<!-- REFACTORED MODAL USING NEW COMPONENT ARCHITECTURE -->
<div class="modal-header ng-hide pm-setting" *ngIf="!showAddOn">
  <h4 class="modal-title">Select Size</h4>
  <button type="button" class="close" aria-label="Close" (click)="closeModal()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body" *ngIf="!showAddOn">
  
  <!-- Product Information Section -->
  <app-wheel-product-info 
    [product]="product"
    [deliveryDate]="deliveryDate"
    [is_hide_cost]="is_hide_cost">
  </app-wheel-product-info>
  
  <!-- Fitment Display Section -->
  <app-wheel-fitment-display 
    [checkfitment]="checkfitment"
    [vehicle]="vehicle"
    [isSearchBySize]="isSearchBySize"
    (onCheckFitment)="handleFitmentCheck($event)">
  </app-wheel-fitment-display>
    <!-- Size Selection Manager (Routes to appropriate selector) -->
  <app-wheel-size-selection-manager
    [product]="product"
    [vehicleWheels]="vehicleWheels"
    [checkfitment]="checkfitment"
    [queryParams]="route.snapshot.queryParams"
    (onCartItemsChange)="handleCartItemsChange($event)"
    (onPriceChange)="handlePriceChange($event)">
  </app-wheel-size-selection-manager>
  <!-- Cart Manager Section (Non-Customization) -->
  <app-wheel-cart-manager
    *ngIf="!isProductCustomization"
    [cartItems]="cartItems"
    [product]="product"
    [isProcessing]="cartProcessing"
    [isSearchBySize]="isSearchBySize"
    [checkfitment]="checkfitment"
    [isProductCustomization]="isProductCustomization"
    [custom_binders]="custom_binders"
    [p_customization_submitted]="p_customization_submitted"
    (onAddToCart)="handleAddToCart($event)"
    (onValidationError)="handleValidationError($event)">
  </app-wheel-cart-manager>

  <!-- Product Customization Sections (Multiple wheels) -->
  <div *ngIf="isProductCustomization && cartResp?.product_customizations" class="customization-sections">
      <!-- Front Wheel Customization Section -->
    <div class="row wheel-customization-section" *ngIf="getFirstKey(cartResp.product_customizations) && custom_binders[0]">
      <div class="col-md-6">
        <div class="cart-left">
          <h4>Select {{ twoCustomizations ? 'Front' : '' }} Wheel Requirements</h4>
          <hr>
          <div class="cart-product-row">            <div class="position-relative">
              <span class="tip">{{ getQuantityForPosition(0) }}</span>
              <img [src]="stringifyImages(product.images) | baseImage | imagePath" alt="Product" />
            </div><div class="cart-left-title">
              <h4>{{ productAddedToCart?.product_full_name || product?.product_full_name }}</h4>
              <div class="cart-product-row-inner">
                <p class="mb-0">Part No: {{ getSkuForPosition(0) }}</p>
                <p class="mb-0">Size: {{ getSizeForPosition(0) }}</p>
                <p class="mb-0">Bolt Pattern: {{ getBoltPatternForPosition(0) }}</p>
                <p class="mb-0">Offset: {{ getOffsetForPosition(0) }}</p>
                <strong *ngIf="!is_hide_cost">
                  {{ getPriceForPosition(0) | currency: productAddedToCart?.vendor?.currency:'symbol' }} / Each
                </strong>
                <strong *ngIf="is_hide_cost">
                  {{ getPriceForPosition(0) | currency: productAddedToCart?.vendor?.currency:'symbol' }} / Each
                </strong>
              </div><div class="form-group mt-2">
                <input class="form-control" type="text" 
                       [(ngModel)]="custom_binders[0].vehicle_year_make_model"
                       placeholder="Enter Vehicle year make model to ensure fitment" />
                <span *ngIf="p_customization_submitted">
                  <span class="error text-danger" 
                        *ngIf="!custom_binders[0]?.vehicle_year_make_model">
                    This field is required
                  </span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6 bl-cart">
        <div class="cart-right">
          <div class="cart-right-row">            <!-- Custom Finish -->
            <div class="cart-right-row-inner" 
                 *ngIf="getCustomizationForWheelPosition(0)?.is_custom_finish">
              <span>Custom Finish:</span>
              <div>
                <select class="form-control custom-finish-control" 
                        [(ngModel)]="custom_binders[0].custom_finish"
                        (change)="handleCustomFinishSelect($event, 0)">
                  <option value="">Choose Finish</option>
                  <option *ngFor="let p_customization of getCustomizationForWheelPosition(0)?.product_customizations"
                          [value]="p_customization.id">
                    {{ p_customization.finish_name }} (+ {{ p_customization.cost | currency: '$' }})
                  </option>
                </select>
                <span *ngIf="p_customization_submitted">
                  <span class="error text-danger" *ngIf="!custom_binders[0]?.custom_finish">This field is required</span>
                </span>
              </div>
            </div>
            
            <!-- Bolt Pattern -->
            <div class="cart-right-row-inner"
                 *ngIf="getCustomizationForWheelPosition(0)?.bolt_patterns?.length > 0">
              <span>Bolt Pattern:</span>
              <select class="form-control" [(ngModel)]="custom_binders[0].bolt_pattern">
                <option value="recommended">Recommended</option>
                <option *ngFor="let bolt_pattern of getCustomizationForWheelPosition(0)?.bolt_patterns"
                        [value]="bolt_pattern">{{ bolt_pattern }}</option>
              </select>
            </div>
              <!-- Offset -->
            <div class="cart-right-row-inner"
                 *ngIf="getCustomizationForWheelPosition(0)?.is_offset_drilling && offsetDropdownValues?.length > 0">
              <span>Offset:</span>
              <select class="form-control" [(ngModel)]="custom_binders[0].offset">
                <option value="recommended">Recommended</option>
                <option *ngFor="let offset of offsetDropdownValues" [value]="offset">{{ offset }}</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Separator -->
    <hr *ngIf="twoCustomizations">    <!-- Rear Wheel Customization Section -->
    <div class="row wheel-customization-section" *ngIf="twoCustomizations && getSecondKey(cartResp.product_customizations) && custom_binders[1]">
      <div class="col-md-6">
        <div class="cart-left">
          <h4>Select Rear Wheel Requirements</h4>
          <hr>
          <div class="cart-product-row">            <div class="position-relative">
              <span class="tip">{{ getQuantityForPosition(1) }}</span>
              <img [src]="stringifyImages(product.images) | baseImage | imagePath" alt="Product" />
            </div>
            <div class="cart-left-title">
              <h4>{{ productAddedToCart?.product_full_name || product?.product_full_name }}</h4>
              <div class="cart-product-row-inner">
                <p class="mb-0">Part No: {{ getSkuForPosition(1) }}</p>
                <p class="mb-0">Size: {{ getSizeForPosition(1) }}</p>
                <p class="mb-0">Bolt Pattern: {{ getBoltPatternForPosition(1) }}</p>
                <p class="mb-0">Offset: {{ getOffsetForPosition(1) }}</p>
                <strong *ngIf="!is_hide_cost">
                  {{ getPriceForPosition(1) | currency: productAddedToCart?.vendor?.currency:'symbol' }} / Each
                </strong>
                <strong *ngIf="is_hide_cost">
                  {{ getPriceForPosition(1) | currency: productAddedToCart?.vendor?.currency:'symbol' }} / Each
                </strong>
              </div><div class="form-group mt-2">
                <input class="form-control" type="text" 
                       [(ngModel)]="custom_binders[1].vehicle_year_make_model"
                       placeholder="Enter Vehicle year make model to ensure fitment" />
                <span *ngIf="p_customization_submitted">
                  <span class="error text-danger" 
                        *ngIf="!custom_binders[1]?.vehicle_year_make_model">
                    This field is required
                  </span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6 bl-cart">
        <div class="cart-right">
          <div class="cart-right-row">            <!-- Custom Finish -->
            <div class="cart-right-row-inner" 
                 *ngIf="getCustomizationForWheelPosition(1)?.is_custom_finish">
              <span>Custom Finish:</span>
              <div>
                <select class="form-control custom-finish-control" 
                        [(ngModel)]="custom_binders[1].custom_finish"
                        (change)="handleCustomFinishSelect($event, 1)">
                  <option value="">Choose Finish</option>
                  <option *ngFor="let p_customization of getCustomizationForWheelPosition(1)?.product_customizations"
                          [value]="p_customization.id">
                    {{ p_customization.finish_name }} (+ {{ p_customization.cost | currency: '$' }})
                  </option>
                </select>
                <span *ngIf="p_customization_submitted">
                  <span class="error text-danger" *ngIf="!custom_binders[1]?.custom_finish">This field is required</span>
                </span>
              </div>
            </div>
            
            <!-- Bolt Pattern -->
            <div class="cart-right-row-inner"
                 *ngIf="getCustomizationForWheelPosition(1)?.bolt_patterns?.length > 0">
              <span>Bolt Pattern:</span>              <select class="form-control" [(ngModel)]="custom_binders[1].bolt_pattern">
                <option value="recommended">Recommended</option>
                <option *ngFor="let bolt_pattern of getCustomizationForWheelPosition(1)?.bolt_patterns"
                        [value]="bolt_pattern">{{ bolt_pattern }}</option>
              </select>
            </div>
              <!-- Offset -->
            <div class="cart-right-row-inner"
                 *ngIf="getCustomizationForWheelPosition(1)?.is_offset_drilling && offsetDropdownValues?.length > 0">
              <span>Offset:</span>
              <select class="form-control" [(ngModel)]="custom_binders[1].offset">
                <option value="recommended">Recommended</option>
                <option *ngFor="let offset of offsetDropdownValues" [value]="offset">{{ offset }}</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>    <!-- Validation Messages -->
    <div class="mt-3" *ngIf="isProductCustomization && !isCustomizationComplete()">
      <div class="alert alert-warning">
        <h6 class="mb-2"><i class="fa fa-exclamation-triangle"></i> Please complete the following requirements:</h6>
        <ul class="mb-0 pl-3">
          <li *ngFor="let message of getValidationMessages()">{{ message }}</li>
        </ul>
      </div>
    </div>

    <!-- Customization Add to Cart Button -->
    <div class="mt-4 d-flex justify-content-end" *ngIf="isProductCustomization">
      <button type="button" 
              class="btn btn-primary"
              [class.btn-loading]="cartProcessing"
              [disabled]="cartProcessing || !isCustomizationComplete()"
              (click)="handleCustomizationAddToCart()">
        <span *ngIf="cartProcessing" class="spinner-border spinner-border-sm me-2"></span>
        <span>{{ cartProcessing ? 'Adding...' : 'Add to Cart' }}</span>
      </button>
    </div>
  </div>

</div>

<!-- Product Customization Modal (Legacy - kept for compatibility) -->
<ng-template #detailpagemodal let-modal>
  <div class="modal-header" *ngIf="isProductCustomization">
    <h4 class="modal-title" id="modal-basic-title">Product Customization</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  
  <div class="modal-body" *ngIf="isProductCustomization">
    <div class="row">
      <div class="col-md-4" *ngIf="productAddedToCart?.images">
        <div class="img-wrap">
          <img [src]="productAddedToCart.images[0] | imagePath" class="img-fluid d-block" alt="img" />
        </div>
      </div>
      <div class="col-md-8">
        <h4>{{ productAddedToCart?.product_full_name || product?.product_full_name || 'Product Name' }}</h4>
        <p class="mb-0">Part No: {{ productAddedToCart?.sku || product?.sku || 'N/A' }}</p>
        
        <!-- Add-on products section -->
        <div *ngIf="prodAddons && prodAddons.length > 0" class="addon-section">
          <h5>Recommended Add-ons</h5>
          <div *ngFor="let addon of prodAddons" class="addon-item">
            <div class="addon-info">
              <h6>{{ addon.product_full_name }}</h6>
              <p>{{ addon.description }}</p>
              <span class="addon-price">${{ addon.price | number:'1.2-2' }}</span>
            </div>
            <button class="btn btn-sm btn-outline-primary" (click)="addToCartAddOns(addon.id)">
              Add to Cart
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  
  <div class="modal-footer" *ngIf="isProductCustomization">
    <button type="button" class="btn btn-outline-dark" (click)="modal.close('Save click')">Continue Shopping</button>
    <button type="button" class="btn btn-primary" (click)="closeModalAndRedirectCart()">View Cart</button>
  </div>
</ng-template>

<!-- Add-ons Modal (Legacy - kept for compatibility) -->
<div class="modal-body" *ngIf="showAddOn">
  <div class="modal-header">
    <h4 class="modal-title">Product successfully added to cart</h4>
    <button type="button" class="close" aria-label="Close" (click)="closeModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  
  <div class="row" *ngIf="productAddedToCart">
    <div class="col-md-4" *ngIf="productAddedToCart.images">
      <div class="img-wrap">
        <img [src]="productAddedToCart.images[0] | imagePath" class="img-fluid d-block" alt="img" />
      </div>
    </div>
    <div class="col-md-8">
      <h4>{{ productAddedToCart.product_full_name || 'Product Name' }}</h4>
      <p class="mb-0">Part No: {{ productAddedToCart.sku || 'N/A' }}</p>
    </div>
  </div>
  
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="closeModal()">Continue Shopping</button>
    <button type="button" class="btn btn-primary" (click)="router.navigateByUrl('/cart')">View Cart</button>
  </div>
</div>
